import React from "react";
import "../assets/css/career.css";
import { ReactTitle } from "react-meta-tags";
import CareerForm from "../Components/CareerForm";
import { motion } from "framer-motion";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";

const containerVariants = {
  exit: {
    x: "-100vw",
    transition: {
      ease: "easeInOut",
      duration: 0.5,
    },
  },
};

const Career = () => {
  return (
    <motion.div
      id="careers"
      className="container my-1 pt-4 pt-md-2"
      variants={containerVariants}
      exit="exit"
    >
      <ReactTitle title="Vibgyor Advisors - Career" />
      <div className="row">
        <Fade>
          <div
            className="col-md-8 mx-auto col-12 careers mb-md-5 mt-md-3 p-lg-1 p-sm-3 "
            style={{ minHeight: "80vh" }}
          >
            <h2 className="text-center text-warning text-uppercase col-12 mt-5 mb-5 mx-auto w-100 border-bottom border-danger h-25">
              Why Work with Us?
            </h2>
            <p
              className=" lead mt-1 w-100 p-2 p-md-0 mx-auto "
              style={{
                width: "90%",
                textAlign: "justify",
                textJustify: "inter-word",
              }}
            >
              We would be happy to add to our team if you have any specific
              skill set, energy and integrity. Contact us in case if you have
              any specific ideas- we need leaders, skilled workers and all kinds
              of people. We love to meet every one who is confident of making a
              change. Our intent is to make a collaborative firm which has
              people who bring all kinds of complimentary skill sets to make a
              significant change to our business.
              <p className="text-center my-4 fs-5 text-warning">
                Just write us an email on{" "}
                <a
                  href="mailto: vibgyoradvisors@gmail.com"
                  className="text-decoration-none"
                >
                  vibgyoradvisors@gmail.com
                </a>
              </p>
            </p>
          </div>
        </Fade>

        {/* <Fade>
          <div className="form col-md-7  ml-1 col-12 mt-3">
            <h2
              className="text-center text-uppercase text-warning mt-5"
              style={{
                display: "block",
                borderBottom: "1px solid red",
                width: "50%",
                margin: "0 auto",
              }}
            >
              Contact Us
            </h2>
            <CareerForm />
          </div>
        </Fade> */}
      </div>
    </motion.div>
  );
};

export default Career;
